import React from 'react';
export const ArrowDownIcon = () => {
  return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="ArrowDownIcon" data-sentry-source-file="ArrowDownIcon.tsx">
      <path d="M5.5575 6.22266L9 9.65766L12.4425 6.22266L13.5 7.28016L9 11.7802L4.5 7.28016L5.5575 6.22266Z" fill="#696F88" data-sentry-element="path" data-sentry-source-file="ArrowDownIcon.tsx" />
    </svg>;
};